<div *ngIf="!isLoading">
    <span *ngIf="place">{{place.type}}</span>
    <span *ngIf="place"> - {{place.name}}</span>
    <span *ngIf="place"> - {{place.reference}}</span>
</div>
<mat-spinner *ngIf="isLoading" [diameter]="32"></mat-spinner>
<div *ngIf="!isLoading && !place" class="error-message">
    <span>Place not found</span>
</div>